import { render, staticRenderFns } from "./BlockscannerInfoMobile.vue?vue&type=template&id=6920f226&scoped=true&"
import script from "./BlockscannerInfoMobile.vue?vue&type=script&lang=js&"
export * from "./BlockscannerInfoMobile.vue?vue&type=script&lang=js&"
import style0 from "./BlockscannerInfoMobile.vue?vue&type=style&index=0&id=6920f226&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920f226",
  null
  
)

export default component.exports